"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var buildSrcSet = function buildSrcSet(densities) {
  return Object.keys(densities).map(function (density) {
    if ("".concat(density) === '1') {
      return densities[density].src;
    }

    return "".concat(densities[density].src, " ").concat(density, "x");
  }).join(', ');
};

var getImageType = function getImageType(densities) {
  var keys = Object.keys(densities);
  return densities[keys[keys.length - 1]].format;
};

var buildSources = function buildSources(type, sizes, breakpoints) {
  return sizes.map(function (size, i) {
    var densities = type[size];
    var imageType = "image/".concat(getImageType(densities));
    var media;

    if (size === 'original' || sizes.length === 0 || !breakpoints || i > breakpoints.length) {
      // only one size
      media = undefined;
    } else if (i === 0) {
      // first size
      media = "(max-width: ".concat(breakpoints[i], "px)");
    } else if (i === sizes.length - 1) {
      // last size
      media = "(min-width: ".concat(breakpoints[i - 1] + 1, "px)");
    } else {
      media = "(min-width: ".concat(breakpoints[i - 1] + 1, "px) and (max-width: ").concat(breakpoints[i], "px)");
    }

    return /*#__PURE__*/_react.default.createElement("source", {
      key: "".concat(imageType, "/").concat(size),
      type: imageType,
      srcSet: buildSrcSet(densities),
      media: media
    });
  });
};

var findFallbackImage = function findFallbackImage(src, rawSrc) {
  var fallbackImage = src;

  if (rawSrc.fallback) {
    var biggestSize = Object.keys(rawSrc.fallback).map(function (key) {
      return parseInt(key, 10);
    }).sort(function (a, b) {
      return b - a;
    }).find(function () {
      return true;
    });

    if (biggestSize) {
      var lowestDensity = Object.keys(rawSrc.fallback[biggestSize]).map(function (key) {
        return parseInt(key, 10);
      }).sort(function (a, b) {
        return a - b;
      }).find(function () {
        return true;
      });

      if (lowestDensity) {
        fallbackImage = rawSrc.fallback[biggestSize][lowestDensity];
      }
    }
  }

  return fallbackImage;
};
/* eslint-disable @typescript-eslint/no-unused-vars */


var Img = function Img(_ref) {
  var src = _ref.src,
      type = _ref.type,
      webp = _ref.webp,
      inline = _ref.inline,
      url = _ref.url,
      original = _ref.original,
      sizes = _ref.sizes,
      densities = _ref.densities,
      breakpoints = _ref.breakpoints,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["src", "type", "webp", "inline", "url", "original", "sizes", "densities", "breakpoints", "style"]);

  var styles = _objectSpread({}, style || {});

  var _ref2 = props,
      rawSrc = _ref2.rawSrc,
      imgProps = _objectWithoutProperties(_ref2, ["rawSrc"]);

  if (!rawSrc) {
    throw new Error("Babel plugin 'react-optimized-image/plugin' not installed or this component could not be recognized by it.");
  } // find fallback image


  var fallbackImage = findFallbackImage(src, rawSrc); // return normal image tag if only 1 version is needed

  if (!rawSrc.webp && Object.keys(rawSrc.fallback).length === 1 && Object.keys(rawSrc.fallback[Object.keys(rawSrc.fallback)[0]]).length === 1) {
    return /*#__PURE__*/_react.default.createElement("img", _extends({
      src: fallbackImage.toString()
    }, imgProps, {
      style: styles
    }));
  }

  return /*#__PURE__*/_react.default.createElement("picture", null, rawSrc.webp && buildSources(rawSrc.webp, sizes || Object.keys(rawSrc.webp), breakpoints || sizes), buildSources(rawSrc.fallback, sizes || Object.keys(rawSrc.fallback), breakpoints || sizes), /*#__PURE__*/_react.default.createElement("img", _extends({
    src: fallbackImage.toString()
  }, imgProps, {
    style: styles
  })));
};

var _default = Img;
exports.default = _default;